// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1RLCd","rootSmall":"AddTileButton_rootSmall__3quNJ"};